import type { FxRateQuery, FxRateResponse, FxRateResult } from '@contexts/FxConverter/domain/FxRate.domain'
import { QueryKeys } from '@shared/domain/queryKeys'
import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

const FRANKFURTER_BASE = '/api/frankfurter'

const fetchFxRate = async (query: FxRateQuery): Promise<FxRateResult> => {
  const { data } = await axios.get<FxRateResponse>(
    `${FRANKFURTER_BASE}/${query.date}`,
    { params: { from: query.from, to: query.to, amount: query.amount } }
  )

  const rate = data.rates[query.to]
  return {
    from: query.from,
    to: query.to,
    date: data.date,
    amount: query.amount,
    rate,
    converted: data.rates[query.to],
  }
}

export const useGetFxRate = (query: FxRateQuery | null) => {
  return useQuery({
    queryKey: [QueryKeys.FxRate, query],
    queryFn: () => fetchFxRate(query!),
    enabled: query !== null,
  })
}
